module.exports = __webpack_public_path__ + "img/logo-800x800.263b9e5d.png";